import { useContext, useState, useEffect, useRef } from "react";
import { WillEditorContext } from "../will-editor";

import STKTextField from "@/components/common/text-field";
import STKCheckbox from "@/components/common/checkbox";

type CheckboxValue = {
    value: string,
    subField?: string
}

type Props = {
    name: string,
    checkboxes: CheckboxValue[]
}

type CheckboxProps = {
    checkbox: CheckboxValue,
    name: string,
    will: any,
    onChange: (checkbox: CheckboxValue) => void
}



const Checkbox = ( props: CheckboxProps ) => {

    const { checkbox, name, will, onChange } = props;

    const subFieldRef = useRef<any>(null);

    const isInitiallyChecked = will?.fields[name]?.value === checkbox.value;

    return (
        <STKCheckbox
            type="radio"
            label={checkbox.value} 
            name={name} 
            defaultChecked={isInitiallyChecked}
            onChange={() => {
                onChange({
                    value: checkbox.value,
                    subField: subFieldRef.current?.value 
                });
            }}
        >
            {checkbox.subField &&
                <STKTextField inputRef={subFieldRef} label={checkbox.subField} defaultValue={will?.fields[name]?.subField} onChange={ ( e:any ) => {
                    onChange({
                        value: checkbox.value,
                        subField: e.currentTarget.value
                    })
                }} />
            }
        </STKCheckbox>
    );
}
  

const WillEditorCheckboxes = ( props:Props ) => {

    const { will, setWillField} = useContext(WillEditorContext);

    const onChange = ( value: CheckboxValue ) => {
        setWillField(props.name, value);
    }
     
    return(
        <div>
            { props.checkboxes.map( ( checkbox:CheckboxValue ) => {
                return <Checkbox key={checkbox.value} name={props.name} checkbox={checkbox} will={will} onChange={onChange} />
            })}
        </div>
         
    );

}

export default WillEditorCheckboxes;